import discord from "./icons/discord.svg";
import opensea from "./icons/opensea.svg";
import twitter from "./icons/twitter.svg";

import AnchorLink from "react-anchor-link-smooth-scroll";

const Footer = (props) => {
  return (
    <div className="Footer">
      <div className="smart-contract" id="contract">
        <a
          href="https://etherscan.io/address/0xbE21418722f3e73b8F8d72Bc15D0dc9E9C3EF681#code"
          target="_BLANK"
          rel="noreferrer"
        >
          Verified Smart Contract Address:
          <u>0xbe21418722f3e73b8f8d72bc15d0dc9e9c3ef681</u>
        </a>
      </div>
      <div className="footer-widgets-wrapper">
        <div className="footer-widgets">
          <div className="footer-column">
            <div className="title">
              Simple and Easily <br /> Identifiable 💎
            </div>
            <p>All rights reserved.</p>
          </div>
          <div className="footer-column">
            <div className="footer-widget-title">Menu</div>
            <ul>
              <li>
                <AnchorLink offset="120" href="#mint">
                  Mint Now
                </AnchorLink>
              </li>
              <li>
                <AnchorLink offset="160" href="#specs">
                  The Specs
                </AnchorLink>
              </li>
              <li>
                <AnchorLink offset="140" href="#erc721">
                  ERC721
                </AnchorLink>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <div className="footer-widget-title">Networks</div>
            <ul>
              <li className="twitter">
                <a
                  href="https://twitter.com/neural_punks"
                  rel="noreferrer"
                  target="_BLANK"
                >
                  <span>
                    <img src={twitter} alt="Digital Icon" />
                  </span>
                  Twitter
                </a>
              </li>
              <li clas="opensea">
                <a
                  href="https://opensea.io/collection/the-neural-punks"
                  rel="noreferrer"
                  target="_BLANK"
                >
                  <span>
                    <img src={opensea} alt="Digital Icon" />
                  </span>
                  OpenSea
                </a>
              </li>
              <li className="discord">
                <a
                  href="https://discord.gg/XuUru6bzpU"
                  rel="noreferrer"
                  target="_BLANK"
                >
                  <span>
                    <img src={discord} alt="Digital Icon" />
                  </span>
                  Discord
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
